const SwiperTestimonials = {

	slider: null,

	init: () => {
		window.addEventListener('load', () => {


			if (typeof Swiper !== typeof undefined) {

				SwiperTestimonials.slider = new Swiper('#testimonials > .swiper', {
					autoplay: {
						delay: 2500,
						disableOnInteraction: true,
					},
					loop: true,
				});

				document.querySelector('#testimonials-next-slide').addEventListener('click', (event) => {
					event.preventDefault();
					event.currentTarget;
					SwiperTestimonials.slider.slideNext()
				});
				document.querySelector('#testimonials-prev-slide').addEventListener('click', (event) => {
					event.preventDefault();
					event.currentTarget;
					SwiperTestimonials.slider.slidePrev()
				});
			}

		}, false);
	}
}


SwiperTestimonials.init()
